import React from 'react';
import { connect } from 'react-redux';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withTranslation, WithTranslation } from 'react-i18next';
import { match } from 'react-router-dom';

// Components
import App from '../../../components/app';
import ErrorMessage from '../../../components/error-message';
import EnhancedForm from '../../../components/form';
import { FormDatas } from '../../../local-types';
// Modules
import { selectors as errorsSelectors, ErrorPayload } from '../../../redux/reducers/errors';
import { actions as companyActions, types as companyTypes } from '../../../redux/reducers/companies';
import { selectors as pendingSelectors } from '../../../redux/reducers/pendingOperations';
// Ressources
import styles from './company-member-add-style';
import { AccountRight, RightRank } from '../../../utils/userUtils';
import { paths } from '../../paths';
import { TParams } from '../../../redux/reducers/api-types';

interface CompanyAddProps extends WithStyles, WithTranslation {
    match: match<TParams>;
    saveMember: (id: string, payload) => any;
    getSaveMemberError: ErrorPayload;
    isSavingMember: boolean;
}

interface State {
    formData: any;
}

class CompanyAddMemberPage extends React.Component<CompanyAddProps, State> {
    inputs: FormDatas[];

    constructor(props: CompanyAddProps) {
        super(props);
        const { t, match } = props;
        const id = match.params.id;
        this.state = {
            formData: {
                company: { id: id },
                admin: false,
                email: '',
                firstname: '',
                lastname: '',
                phone_number: '',
            },
        };

        this.inputs = [
            {
                title: t('add_member.title'),
                datas: [
                    { id: 'lastname', label: t('common:form.lastname'), required: true },
                    {
                        id: 'firstname',
                        label: t('common:form.firstname'),
                        required: true,
                    },
                    {
                        id: 'email',
                        label: t('common:form.email'),
                        hint: t('common:form.email_hint'),
                        type: 'email',
                        required: true,
                    },
                    {
                        id: 'phone_number',
                        label: t('common:form.phone_number'),
                        type: 'tel',
                        required: true,
                    },
                    {
                        id: 'admin',
                        label: t('add_member.admin'),
                        type: 'boolean',
                        required: true,
                    },
                ],
            },
        ];
    }

    handleSubmit = (formData, event): void => {
        const { saveMember, match } = this.props;
        const id = match.params.id;
        this.setState({ formData: formData });
        saveMember(id, formData);
    };

    render() {
        const { match, getSaveMemberError, isSavingMember } = this.props;
        const id = match.params.id;

        return (
            <App needRights={{ name: AccountRight.COMPANY_SETTINGS, mode: RightRank.W }}>
                <ErrorMessage payload={getSaveMemberError} />
                <EnhancedForm
                    payload={this.state.formData}
                    inputs={this.inputs}
                    backRoute={`${paths.companies}/${id}`}
                    onSubmit={this.handleSubmit}
                    loader={isSavingMember}
                />
            </App>
        );
    }
}

const CompanyAddMemberPageWithStyleAndTranslation = withStyles(styles)(
    withTranslation(['company', 'common'])(CompanyAddMemberPage),
);

const mapStateToProps = (state) => ({
    getSaveMemberError: errorsSelectors.getSaveMemberError(state),
    isSavingMember: pendingSelectors.isPending(state, companyTypes.SAVE_COMPANY_MEMBER),
});

const mapDispatchToProps = {
    saveMember: companyActions.saveMember,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyAddMemberPageWithStyleAndTranslation);
